import { render, staticRenderFns } from "./OfficeSelect.vue?vue&type=template&id=70fc7b2c&"
import script from "./OfficeSelect.vue?vue&type=script&lang=ts&"
export * from "./OfficeSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports